import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomsState } from './customs.state';
import { NgxsModule } from '@ngxs/store';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgxsModule.forFeature([CustomsState])
  ]
})
export class CustomsStoreModule { }
